import { createContext, ReactNode, useState } from 'react'
import { ThemeProvider, useTheme } from 'styled-components'

import { useDarkMode } from '@/hooks/useDarkMode'
import { useIsEmbedded } from '@/hooks/useIsEmbedded'
import { persistDarkMode, readDarkModeForVite } from '@/storage/darkModeStorage'

// TODO: Theme and dark mode should be in design-system (https://github.com/betagouv/mon-entreprise/issues/2563)

type DarkModeContextType = [boolean, (darkMode: boolean) => void]

export const DarkModeContext = createContext<DarkModeContextType>([
	false,
	() => {
		// eslint-disable-next-line no-console
		console.error('No dark mode provider found')
	},
])

export const DarkModeProvider = ({
	children,
	darkModeParDéfaut,
}: {
	children: ReactNode
	darkModeParDéfaut?: boolean
}) => {
	const [darkMode, _setDarkMode] = useState<boolean>(
		darkModeParDéfaut ?? readDarkModeForVite()
	)

	const setDarkMode = (darkMode: boolean) => {
		_setDarkMode(darkMode)
		persistDarkMode(darkMode)

		document.body.style.backgroundColor = darkMode ? '#0f172a' : ''

		// https://www.youtube.com/watch?v=Pr8ETbGz35Q
		// eslint-disable-next-line no-console
		console.log(darkMode ? 'Nuit' : 'Jour')
	}

	const finalDarkMode = !useIsEmbedded() && darkMode

	return (
		<DarkModeContext.Provider value={[finalDarkMode, setDarkMode]}>
			{children}
		</DarkModeContext.Provider>
	)
}

export type ThemeType = 'default' | 'light' | 'dark'

export const ForceThemeProvider = ({
	children,
	forceTheme,
}: {
	children: ReactNode
	forceTheme?: ThemeType
}) => {
	const [darkMode] = useDarkMode()
	const currentTheme = useTheme()

	return (
		<ThemeProvider
			theme={{
				...currentTheme,
				darkMode:
					forceTheme === undefined || forceTheme === 'default'
						? darkMode
						: forceTheme === 'dark',
			}}
		>
			{children}
		</ThemeProvider>
	)
}
